import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  DEFAULT_PAGE_SIZE,
  readTableState,
  writeTableState,
  type TableState,
} from './tableState'

export interface TableUrlState {
  state: TableState
  /** Holatning bir qismini yangilaydi va URL'ga yozadi */
  patch: (partial: Partial<TableState>) => void
  /** Filtr, qidiruv va saralashni tozalaydi (sahifa hajmi qoladi) */
  reset: () => void
}

interface Options {
  /** Bitta sahifada bir nechta jadval bo'lsa — URL parametr prefiksi */
  prefix?: string
  defaultPageSize?: number
}

export function useTableUrlState(options: Options = {}): TableUrlState {
  const { prefix = '', defaultPageSize = DEFAULT_PAGE_SIZE } = options
  const [searchParams, setSearchParams] = useSearchParams()

  const state = useMemo(
    () => readTableState(searchParams, prefix, defaultPageSize),
    [searchParams, prefix, defaultPageSize],
  )

  const patch = useCallback(
    (partial: Partial<TableState>) => {
      setSearchParams(
        (current) => {
          const base = readTableState(current, prefix, defaultPageSize)
          const next: TableState = { ...base, ...partial }

          // Filtr yoki qidiruv o'zgarsa BIRINCHI sahifaga qaytamiz.
          // Aks holda 7-sahifada turib filtr qo'yilsa, natija 2 sahifa
          // bo'lsa ham 7-sahifa so'raladi va jadval bo'sh ko'rinadi —
          // foydalanuvchi "hech narsa topilmadi" deb o'ylaydi.
          const resetsPage =
            partial.filters !== undefined ||
            partial.search !== undefined ||
            partial.pageSize !== undefined
          if (resetsPage && partial.page === undefined) next.page = 1

          return writeTableState(current, prefix, next, defaultPageSize)
        },
        // `replace` — har filtr bosishi tarixga yangi yozuv qo'shmasin,
        // aks holda "orqaga" tugmasi o'nlab marta bosilishi kerak bo'lardi
        { replace: true },
      )
    },
    [setSearchParams, prefix, defaultPageSize],
  )

  const reset = useCallback(() => {
    patch({ filters: {}, search: '', sortField: null, sortOrder: null, page: 1 })
  }, [patch])

  return { state, patch, reset }
}
